<div class="toolbar-holder">
  <div class="toolbar justify-content">
    <div class="flex-start">
      <div class="justify-content flex-wrap">
        <rl-page-navigation [currentPage]="page" (pageChanged)="pageChanged($event)" class="justify-content flex-wrap"></rl-page-navigation>
        <!-- scale -->
        <div class="flex-basis seperator view-scale">
          <select [ngModel]="zoom" (ngModelChange)="changeZoom($event)" class="scale" accessibleTooltip [tooltip]="'scale.view' | translate" triggers="manual" placement="bottom" [attr.aria-label]="'scale.view' | translate">
            <option *ngFor="let i of zoomOptions" [ngValue]="i">{{ i.label }}</option>
          </select>
        </div>
        <!-- search -->
        <div class="flex-basis seperator search-box-btn">
          <rl-search (onSearch)="search($event)" (getNextResult)="nextResult()"></rl-search>
        </div>
        <rl-annotator-design-tools class="flex-bar" *ngIf="showAnnotations" [disabledTools]="disabledDesignTools" (onSelectTool)="selectTool($event)"></rl-annotator-design-tools>
        <!-- rotate -->
        <div class="flex-basis rotate-file" [ngClass]="showAnnotations ? 'seperator' : 'no-seperator'">
          <a
            (click)="rotate()"
            href="javascript://"
            class="btn btn-clear rotate-cw"
            attr.aria-label="{{ 'pdfViewer.rotateCw' | translate }}"
            attr.value="{{ 'pdfViewer.rotateCw' | translate }}"
            accessibleTooltip
            [tooltip]="'pdfViewer.rotateCw' | translate"
            triggers="manual"
            placement="bottom">
            <span class="sr-only">{{ 'pdfViewer.rotateCw' | translate }}</span>
            <i class="fa fa-repeat" attr.aria-hidden="true"></i>
          </a>
        </div>
        <div class="flex-basis no-seperator" *ngIf="showAnnotations">
          <button
            class="btn btn-clear"
            [ngClass]="isToolSelected('hideAnnotations') ? 'bottom-marked' : ''"
            id="toggle-show-annotations"
            (click)="toggleSelectTool('hideAnnotations')"
            type="button"
            data-tooltype="point"
            accessibleTooltip
            [tooltip]="(isToolSelected('hideAnnotations') ? 'annotations.showAll' : 'annotations.hideAll') | translate"
            triggers="manual"
            placement="bottom"
            [attr.aria-label]="(isToolSelected('hideAnnotations') ? 'annotations.showAll' : 'annotations.hideAll') | translate">
            <span class="sr-only">{{ (isToolSelected('hideAnnotations') ? 'annotations.showAll' : 'annotations.hideAll') | translate }}</span>
            <i class="fa no-margin fa-eye-slash" attr.aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
